import type { ITranslation } from '../../../models/press/translation.model';

export class TranslationApiModel {
  public static mapToBusinessModel(apiModel: TranslationApiModel): ITranslation | undefined {
    if (!apiModel) {
      return undefined;
    }
    return { sv: apiModel.sv };
  }

  public sv!: string;
}
